import { DataTypes } from "@lexriver/data-types";
import { Path } from "../../Path";
import { Settings } from "../../Settings";
import { EnumThumbnailWidth } from "../enums/EnumThumbnailWidth";
import { JsonSeo } from "./JsonSeo";

export interface JsonProduct {
    readonly id: number
    readonly sku: string
    //readonly sDesc: string
    readonly description: string
    //readonly thumbImage: string
    readonly fullImage?: string
    //readonly cdate: number
    //readonly mdate: number
    readonly fullImageFtpSize?: number
    readonly fullImageFtpLastModificationDate?:string

    readonly thumbnailImage?: string
    readonly thumbnailImageFtpSize?: number
    readonly thumbnailImageFtpLastModificationDate?:string
    //thumbnailsDate?:Date
    readonly published?:boolean //if has fullImage and thumbnails

    readonly createDate: string
    readonly updateDate: string
    readonly name: string
    readonly retailPrice: number
    readonly retailPriceDollar?:number
    readonly wholesalePrice: number
    readonly wholesalePriceDollar?:number
    readonly categoryId: number
    //readonly typeId: number
    readonly type:string
    readonly attribute: {[name:string]:(string|number)[]}
    readonly properties?:{[name:string]:string|number}
    readonly similarProductIds?:number[]

    readonly quantity:number
    readonly quantityBySize?: {[size:number]:number}
    //typeName?: string
    //selectedQuantity:number
    //selectedSize:number
    //chosenAttributes?: {size:number}
    readonly orderId?:number
    readonly hidden?:boolean
    isBestSeller?:boolean 
    // factorySku?:string

    images?:string[]
    seo?:JsonSeo    
    url:string
}

export function isValidJsonProduct(x:any){
    return (
        x.id && DataTypes.isNumber(x.id) &&
        x.sku && DataTypes.isString(x.sku)
        //TODO: complete this
    )
}

export function getImageUrlForFullImage(product:JsonProduct){
    if(!product.fullImage) return 'no-image' //
    let hash = getHash(product)
    //return `https://uvelina.ru/components/com_virtuemart/shop_image/product/${fullImageFilename}`
    let fullImageFilename = encodeURIComponent(product.fullImage)
    //return isProduction?`/product-images/${fullImageFilename}`:`/product-images/${fullImageFilename}`
    return Path.join(Settings.productImagesPath, fullImageFilename)+'?'+hash
}

function getHash(product:JsonProduct){
    return product.fullImageFtpSize+'!'+product.thumbnailImageFtpSize
}



export function getImageUrlForThumbImage(product:JsonProduct, width?:EnumThumbnailWidth){
    if(!product.thumbnailImage) return `no-thumbnail-image`
    let hash = getHash(product)
    let thumbImageFilename = product.thumbnailImage
    //return `https://uvelina.ru/components/com_virtuemart/shop_image/product/${thumbImageFilename}`
    thumbImageFilename = encodeURIComponent(thumbImageFilename)
    if(width){
        //return isProduction?`/product-images/${width}/${thumbImageFilename}`:`https://uvelina.ru:2020/product-images/${width}/${thumbImageFilename}`
        return Path.join(Settings.productImagesPath, width, thumbImageFilename)+'?'+hash
    }
    //return isProduction?`/product-images/${thumbImageFilename}`:`https://uvelina.ru:2020/product-images/${thumbImageFilename}`
    return Path.join(Settings.productImagesPath, thumbImageFilename)+'?'+hash
}


export function getProductProperties(product:JsonProduct){
    if(!product.properties) return []
    const result:{[key:string]:string|number} = {}
    for(let propertyName of Object.keys(product.properties)){
        let skip = false
        const keywordsToIgnore = ['Артикул завода', 'покупают', 'Тип товара', 'Поставщик', 'Хит продаж', 'Размер колец', 'ID группы', 'Диаметр', 'Цвет вставки', 'Коллекция']
        for(let keywordToIgnore of keywordsToIgnore){
            if(propertyName.toLocaleLowerCase().indexOf(keywordToIgnore.toLocaleLowerCase()) >= 0){
                skip = true
                continue
            }
        }
        if(!skip){
            result[propertyName] = product.properties[propertyName]
        }
    }
    // if(result['Вставка']){
    //     if(result['Диаметр']){
    //         result['Вставка'] += ' '+result['Диаметр']
    //         delete result['Диаметр']
    //     }
    //     if(result['Цвет вставки']){
    //         result['Вставка'] += ' '+result['Цвет вставки']
    //         delete result['Цвет вставки']
    //     }
    // }
    
    // console.log('product properties=', this.attrs.product.properties, 'result=', result)
    // Везде сперва покрытие, потом вставка, потом размер, потом вес 

    const sortedKeys = ['Покрытие', `Вставка`, `Размер`, `Вес`]

    function getIndexOfSortedKey(key:string){
        for(let i=0;i<sortedKeys.length;i++){
            if(key.indexOf(sortedKeys[i])>=0){
                return i
            }
        }
        return 999
    }

    const sortedResult:{key:string, value:string|number}[] = []
    for( let [key,value] of Object.entries(result)){
        sortedResult.push({key,value})
    }

    sortedResult.sort((a,b) => {
        return getIndexOfSortedKey(a.key) - getIndexOfSortedKey(b.key)
    })
    
    
    return sortedResult

}

export function checkIfProductHasCorrectAttribute(product:JsonProduct){
    if(!product) return false
    if(!product.attribute) return false
    if(!DataTypes.isObject(product.attribute)) return false
    for(const value of Object.values(product.attribute)){
        if(!DataTypes.isArray(value)) return false
    }
    return true
}

export function checkIfProductHasQuantityBySize(product:JsonProduct){
    return product.quantityBySize && Object.keys(product.quantityBySize).length>0
}


export function getRealProductQuantity(product:JsonProduct){
    if(product.quantityBySize && typeof product.quantityBySize === 'object' && Object.keys(product.quantityBySize).length>0){
        return Object.values(product.quantityBySize).reduce((p, c) => p+c, 0)
    }
    return product.quantity
}
